var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { deriveRowId } from "@hyper-hyper-space/hhs3_rdb";
import { formatValidationFailure, ValidationRejectedError } from "@hyper-hyper-space/hhs3_mvt";
import { DiagnosticBag, err, ok } from "../diagnostics.js";
import { compileCreate } from "../compile/create.js";
import { executeLog } from "./history.js";
export function execute(bound) {
    return __awaiter(this, void 0, void 0, function* () {
        const diagnostics = new DiagnosticBag();
        try {
            if (bound.kind === 'create-database' || bound.kind === 'create-schema' || bound.kind === 'create-tablegroup') {
                return ok({ kind: 'create-plan', plan: yield compileCreate(bound) });
            }
            return ok(yield executeRuntime(bound));
        }
        catch (e) {
            if (e instanceof ValidationRejectedError) {
                diagnostics.add('VALIDATION_REJECTED', formatValidationFailure(e.why), bound.ast.span);
                return err(diagnostics.all());
            }
            diagnostics.add('EXECUTION_FAILED', e instanceof Error ? e.message : String(e), bound.ast.span);
            return err(diagnostics.all());
        }
    });
}
function executeRuntime(bound) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        switch (bound.kind) {
            case 'add-member': {
                if (bound.database.db === undefined)
                    throw new Error('ADD target database is not loaded');
                const entryHash = bound.member === 'schema'
                    ? yield bound.database.db.addSchema(bound.memberId, bound.note, bound.author, bound.at)
                    : yield bound.database.db.addGroup(bound.memberId, bound.note, bound.author, bound.at);
                return { kind: 'add-member', member: bound.member, entryHash, database: bound.database.id, memberId: bound.memberId };
            }
            case 'alter-schema': {
                if (bound.schema.schema === undefined)
                    throw new Error('ALTER SCHEMA target is not loaded');
                const entryHash = yield bound.schema.schema.updateSchema(bound.rules, bound.author, undefined, bound.at);
                return { kind: 'alter-schema', entryHash, schema: bound.schema.id, rules: bound.rules.length };
            }
            case 'update-schema': {
                if (bound.group.group === undefined)
                    throw new Error('UPDATE SCHEMA target group is not loaded');
                const entryHash = yield bound.group.group.deploy(bound.version, bound.author, bound.at);
                return { kind: 'update-schema', entryHash, group: bound.group.id };
            }
            case 'update-ref': {
                if (bound.group.group === undefined)
                    throw new Error('UPDATE REF target group is not loaded');
                const entryHash = yield bound.group.group.observe(bound.ref, bound.version, bound.author, bound.at);
                return { kind: 'update-ref', entryHash, group: bound.group.id, ref: bound.ref };
            }
            case 'insert': {
                const entryHash = yield bound.table.table.insert(bound.uuid, bound.values, bound.author, bound.at);
                return {
                    kind: 'insert',
                    entryHash,
                    table: `${bound.table.groupId}.${bound.table.tableName}`,
                    rowId: deriveRowId(bound.uuid, (_a = bound.author) === null || _a === void 0 ? void 0 : _a.keyId),
                    uuid: bound.uuid,
                };
            }
            case 'update': {
                const entryHash = yield bound.table.table.update(bound.rowId, bound.values, bound.author, bound.at);
                return { kind: 'update', entryHash, table: `${bound.table.groupId}.${bound.table.tableName}`, rowId: bound.rowId };
            }
            case 'delete': {
                const entryHash = yield bound.table.table.delete(bound.rowId, bound.author, bound.at);
                return { kind: 'delete', entryHash, table: `${bound.table.groupId}.${bound.table.tableName}`, rowId: bound.rowId };
            }
            case 'bundle': {
                if (bound.group.group === undefined)
                    throw new Error('BUNDLE target group is not loaded');
                const entryHash = yield bound.group.group.bundle(bound.writes, bound.author, bound.at);
                return { kind: 'bundle', entryHash, group: bound.group.id, writes: bound.writes.length };
            }
            case 'set-view': {
                return bound.from === undefined
                    ? { kind: 'set-view', at: bound.at }
                    : { kind: 'set-view', at: bound.at, from: bound.from };
            }
            case 'select': {
                const view = yield bound.table.table.getView(bound.at, bound.from);
                const result = {
                    kind: 'select',
                    table: `${bound.table.groupId}.${bound.table.tableName}`,
                    query: bound.query,
                    rows: yield view.query(bound.query),
                };
                if (bound.ast.projection === '*') {
                    result.columns = yield view.getColumns();
                }
                return result;
            }
            case 'log':
                return executeLog(bound);
        }
    });
}
